import {Injectable} from '@angular/core';
import {GatewayRpcService, Namespace, Version} from "../gateway";
import {BatchActions, BatchQuickEdit, Status} from './'
import {Queue} from '../queue'

@Injectable({
  providedIn: 'root'
})
export class BatchRpcService {

  queueService: Queue;

  constructor(private rpc: GatewayRpcService) {
    this.queueService = new Queue();
  }

  async createBatchDocuments(did: string[], bid: string) {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Batch,
          action: BatchActions.CreateBatchDocuments,
          data: {bid, did}
        });
    } catch (e) {
      return e;
    }
  }

  async updateBatchDocuments(bid: string, newBid: string) {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Batch,
          action: BatchActions.UpdateBatchDocuments,
          data: {bid, newBid}
        });
    } catch (e) {
      return e;
    }
  }

  async getBatchesMajorityShippedStatus(bid: string[]) {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Batch,
          action: BatchActions.BatchesMajorityShippedStatus,
          data: {bid}
        });
    } catch (e) {
      return e;
    }
  }

  async processQuickEdit(res: BatchQuickEdit) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.ProcessQuickEdits, data: res});
    } catch (e) {
      return e;
    }
  }

  async getLatestBatch(bid: string) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetLatestBatch, data: {bid}});
    } catch (e) {
      return e;
    }
  }
  async getBatch(bid: string) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetBatch, data: {bid}});
    } catch (e) {
      return e;
    }
  }
  async get(bid: string) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.Get, data: {bid}});
    } catch (e) {
      return e;
    }
  }
  async getStatuses() {
    try {
      const res = await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetStatuses, data: {}});
      return res['statuses'] ?? [];
    } catch (e) {
      return e;
    }
  }

  async getBatches(batches:string[], page:any) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetBatches, data: {batches, page:JSON.stringify(page)}});
    } catch (e) {
      return e;
    }
  }

  async exportWorkspace(batches:string[], page:any) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.ExportBatches, data: {batches, page:JSON.stringify(page)}});
    } catch (e) {
      return e;
    }
  }
  async exportBatches(batches:string[], page:any) {
    try {
     return await this.rpc.request(
          {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.ExportBatches, data: {batches, page:JSON.stringify(page)}});
    } catch (e) {
      return e;
    }
  }
  async getBatchListByAwbBol(awb_bol_number:string){
    try {
      const res = await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetBatchList, data: {awb_bol_number}});
      return res.batches ?? [];
    } catch (e) {
      return e;
    }
  }

  async getBatchListByBarcode(barcode:string){
    try {
      const res = await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetBatchList, data: {barcode}});
      return res.batches ?? [];
    } catch (e) {
      return e;
    }
  }
  async getBatchListBookmarked(page:number = 1){
    try {
      const res = await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.GetBatchList, data: {barcode:"", bookmarks:true, page}});
      return res.batches ?? [];
    } catch (e) {
      return e;
    }
  }

  async bookmark(bid:string){
    try {
      const res = await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.Bookmark, data:{bid}});
      return res.batches ?? [];
    } catch (e) {
      return e;
    }
  }
}

